import React from "react";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { formatFinance } from "../../../utils/formatters";

export default function CategoryRowWithCheckbox({
  category,
  index,
  isSelected,
  setIsSelected,
}) {
  const [checked, setChecked] = React.useState(isSelected || false);

  const title = category?.title ?? undefined;

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setIsSelected(event.target.checked, index);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        pl: 2,
        "&:hover": {
          backgroundColor: grey["200"],
        },
      }}
    >
      <Box>
        <Typography variant="body1">{title}</Typography>
      </Box>
      <Box>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Box>
    </Stack>
  );
}
